export default "assets/images/contact-4e2dd952.jpg";